import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsKitesurfNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M21.006 15.58l-2.01-8.706c.05-1.891-.516-3.695-1.845-5.024C15.506.205 13.14-.27 10.774.14c-2.37.408-4.837 1.706-6.883 3.752S.547 8.405.14 10.775c-.408 2.366.065 4.731 1.71 6.376 1.463 1.463 3.502 2.001 5.598 1.813a.999.999 0 00.421-.136l7.822 2.068-1.397 1.397 1.414 1.415 8-8-1.414-1.415zM5.306 5.306a12.329 12.329 0 013.02-2.232l1.322 3.633c-.56.386-1.098.833-1.603 1.338S7.093 9.09 6.707 9.648L3.074 8.327a12.328 12.328 0 012.232-3.02zm6.111.415l-1.235-3.395c.314-.091.625-.163.932-.216 1.92-.33 3.56.092 4.623 1.154.565.565.948 1.292 1.134 2.139-1.056-.423-2.252-.497-3.437-.293a8.87 8.87 0 00-2.017.611zM9.459 9.46c.29-.29.592-.555.9-.795l.969 2.664-2.664-.969c.24-.308.504-.609.795-.9zm-7.134.724l3.396 1.234a8.87 8.87 0 00-.611 2.018c-.205 1.184-.13 2.38.292 3.436-.846-.185-1.573-.569-2.139-1.134-1.062-1.062-1.484-2.703-1.153-4.623.053-.306.124-.617.215-.931zm10.125 3.681L17.586 19l-.26.26-9.78-2.586c-.486-.732-.667-1.732-.466-2.9a6.943 6.943 0 01.525-1.671zm6.888 3.384l-.338.338-5.136-5.136-1.762-4.845a6.943 6.943 0 011.672-.524c1.416-.244 2.585.073 3.329.817.035.035.07.071.103.108z"
        fill=""
      />
    </svg>
  )
);
SvgSportsKitesurfNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsKitesurfNormalSmall;
